import { render, staticRenderFns } from "./asCenTo.vue?vue&type=template&id=5f08ce2e&scoped=true&"
import script from "./asCenTo.vue?vue&type=script&lang=js&"
export * from "./asCenTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f08ce2e",
  null
  
)

export default component.exports